import cx from 'classnames';
import TwCitySelector from 'tw-city-selector';
import { FC, FormEventHandler as FEH, useEffect } from 'react';

import * as API from 'api';
import * as Type from './type';

import style from "./style.module.scss";
import { isTC } from 'utils';

interface GetContactData {
  (e: React.FormEvent<HTMLFormElement>): Type.IContactData;
}

const getContactData: GetContactData = ({ currentTarget }) => {
  const formData = new FormData(currentTarget);

  return formData.get && false ?
    {
      ishara: API.getToken(),
      name: formData.get("username").toString(),
      phone: formData.get("phone").toString(),
      address: (
        formData.get("zipcode").toString() +
        formData.get("county").toString() +
        formData.get('district').toString() +
        formData.get("add").toString()),
      email: formData.get("email").toString(),
    }:
    {
      ishara: API.getToken(),
      /** @ts-ignore */
      name: document.getElementsByName("username")[0].value,
      /** @ts-ignore */
      phone: document.getElementsByName("phone")[0].value,
      address: (
        /** @ts-ignore */
        document.getElementsByName("zipcode")[0].value.toString() +
        /** @ts-ignore */
        document.getElementsByName("county")[0].value.toString() +
        /** @ts-ignore */
        document.getElementsByName('district')[0].value.toString() +
        /** @ts-ignore */
        document.getElementsByName("add")[0].value.toString()),
      /** @ts-ignore */
      email: document.getElementsByName("email")[0].value.toString(),
    };
};

export const InputContact: FC<Type.IInputContact> = ({
  func,
  isWin = false,
}) => {
  const submitContact: FEH<HTMLFormElement> = e => {
    e.preventDefault();
    const contactData: Type.IContactData = getContactData(e);

    if(!isTC(contactData.name)) {
      return alert('中⽂姓名請輸入中文');
    }

    /** @ts-ignore */
    if(!document.getElementsByName("add")[0].value.toString() && !contactData.email) {
      return alert('收件地址/電子信箱請擇一填寫');
    }

    func(contactData);
  };

  useEffect(() => {
    new TwCitySelector();
  }, []);

  return (
    <form className="success_formin inner" onSubmit={submitContact}>
      <div className="form_title">
        {isWin ? "請填寫以下資料以利辦理領獎手續": "請填寫以下資料以獲得抽抽週⼤禮資格"}
      </div>
      <div className="form">
        <div className="form_info">
          <p>*獎項統一於2021年8月23⽇後陸續寄出</p>
          <p>*姓名手機為必填，收件地址/電⼦信箱擇⼀填寫</p>
          <p style={{"color" :"red"}}>*請務必留意資料正確能順利聯繫，無法聯繫後續無法領獎</p>
        </div>
        <div className="form_list">
          <label htmlFor="username">中⽂姓名<span className="red">*</span></label>
          <input type="text" name="username" id="username" maxLength={20} required />
        </div>
        <div className="form_list">
          <label htmlFor="phone">手機號碼<span className="red">*</span></label>
          <input type="tel" name="phone" id="phone" minLength={10} maxLength={10} required />
        </div>
        <div className={cx("form_list", style.address)}>
          <label htmlFor="add">收件地址
            {isWin && <span className="red">*</span>}
          </label>
          <div className={style.input}>
            <span className={style.twCitySelector} role="tw-city-selector" data-has-zipcode />
            <input type="text" name="add" id="add" className={style.street} placeholder="詳細路名" required={isWin} />
          </div>
        </div>
        <div className="form_list">
          <label htmlFor="email">電子信箱
            {isWin && <span className="red">*</span>}
          </label>
          <input type="email" name="email" id="email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,}$"  required={isWin} />
        </div>
      </div>
      <div className="success_btbox">
        {/* TODO: 也許要把 div 拿掉 */}
        <button className="bt_send"><div>確認送出</div></button>
      </div>
    </form>
  );
};
